import script from "./publish.vue?vue&type=script&setup=true&lang=js"
export * from "./publish.vue?vue&type=script&setup=true&lang=js"

import "./publish.vue?vue&type=style&index=0&id=0cdec937&lang=scss&scoped=true"

import exportComponent from "D:\\办公\\projects\\drl-live\\drl-live-jk\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cdec937"]])

export default __exports__